/* eslint-disable react/prop-types, no-unused-vars */
import React, { useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Empty, Spin, Pagination } from 'antd'
import { LuPartyPopper } from 'react-icons/lu'
import { FaRegThumbsUp } from 'react-icons/fa'
import { BiMoviePlay } from 'react-icons/bi'
import { Swiper } from '../swiper-element'
import InView from '../category-in-view'
import { CardCourse, PrimaryButton } from '../../../../components'
import TabBar from '../../../../components/tab-bar'
import { useCourseList, useHistories, useProfile } from '../../../../hooks'
import { COMPANY_NAME_JP, COURSE_ATTRIBUTES, DEFAULT_LIMIT_COURSE_LIST, DEFAULT_PAG, ROUTES_NAME, TabsName, USER_ROLE } from '../../../../constants'

import { dateFormat, isMappable, STORAGE } from '../../../../utils'
import Wrapper from './styled'
import { FULL_DATE_TIME } from '../../../../utils/date'
import { TYPE, PARAMS } from '../../../../constants/courseList'

const initialState = {
  result: [],
  page: DEFAULT_PAG.page,
  pages: DEFAULT_PAG.pages,
  limit: DEFAULT_LIMIT_COURSE_LIST,
  total: DEFAULT_PAG.total
}

const initialParams = {
  [PARAMS.NEW]: 0,
  [PARAMS.RECOMMENDED]: 0,
  [PARAMS.RECENT_VIEWS]: 0,
  [PARAMS.CATEGORY]: 0
}

const CourseTab = ({
  courseSearch,
  categories,
  companyCategories,
  nissokenCategories,
  channelCounts,
  fromTab,
  getCourseByTab,
  needsToLoadCompanyCategories,
  setNeedsToLoadCompanyCategories,
  needsToLoadNissokenCategories,
  setNeedsToLoadNissokenCategories,
  needsToLoadUncategorizedCompany,
  setNeedsToLoadUncategorizedCompany,
  needsToLoadUncategorizedNissoken,
  setNeedsToLoadUncategorizedNissoken,
  isSidebarToggle
}) => {
  // Use hooks
  const { t } = useTranslation()
  const history = useHistories()
  const { totalCourseCompany, totalCourseNissoken } = channelCounts
  const { profile, profile: { isWorkSpace }, userRole } = useProfile()
  const {
    isLiking,
    isUpdatingBookmark,
    courseCost,
    courseFree,
    courseCompany,
    courseCompanyNew,
    courseCompanyRecommended,
    courseCompanyRecentViews,
    courseNissoken,
    courseNissokenNew,
    courseNissokenRecommended,
    courseNissokenRecentViews,
    coursesNissokenByCategories,
    coursesCompanyByCategories,
    courseUncategorizedNissoken,
    courseUncategorizedCompany,
    courseListTab,
    courseCompanyNewIsLoading,
    courseCompanyRecommendedIsLoading,
    courseCompanyRecentViewsIsLoading,
    courseNissokenNewIsLoading,
    courseNissokenRecommendedIsLoading,
    courseNissokenRecentViewsIsLoading,
    coursesNissokenByCategoriesIsLoading,
    coursesCompanyByCategoriesIsLoading,
    courseUncategorizedNissokenIsLoading,
    courseUncategorizedCompanyIsLoading,
    onChangeTab,
    getCourseNissoken,
    getCourseCompany,
    getCourseNissokenByCategories,
    getCourseCompanyByCategories,
    getUncategorizedCourseNissoken,
    getUncategorizedCourseCompany,
    updateViewedTabAction,
    updateViewedSearchResultTabAction,
    addCourseToCart,
    voteLikeCourse,
    isSearching,
    error,
    resetFilterCourseListAction,
    updateBookmarkAction,
    isCourseListPage,
    isSearchResultPage,
    viewedTab,
    viewedSearchResultTab
  } = useCourseList({ userId: profile.userId })
  // End use hooks

  // Use states
  const searchResults = useMemo(() => {
    if (isSearchResultPage) {
      return courseListTab === TabsName.NISSOKEN_COURSE ? courseNissoken : courseCompany
    }
    return initialState
  }, [courseNissoken, courseCompany, courseListTab, isSearchResultPage])

  const [slideParams, setSlideParams] = useState({
    [TabsName.COMPANY_COURSE]: initialParams,
    [TabsName.NISSOKEN_COURSE]: initialParams
  })
  // End use states

  const isUserCompany = useMemo(() => (
    [USER_ROLE.COMPANY_EMPLOYEE, USER_ROLE.COMPANY_ADMIN, USER_ROLE.SUB_ADMINISTRATOR, USER_ROLE.COURSE_ADMIN].includes(userRole)
  ), [userRole])

  const isNissoken = useMemo(() => (userRole === USER_ROLE.NISSHOKEN_ADMIN), [userRole])

  useEffect(() => {
    if (history.location.pathname.includes(ROUTES_NAME.COURSE_LIST)) {
      localStorage.setItem(STORAGE.SOURCE_PATH, history.location.pathname)
    }
  }, [history.location.pathname])

  const onTabChange = (tab) => {
    onChangeTab(tab.key)
    if (isCourseListPage && !viewedTab[tab.key]) {
      getCourseByTab({ tab: tab.key })
      updateViewedTabAction({ tab: tab.key })
    }

    if (isSearchResultPage && !viewedSearchResultTab[tab.key]) {
      getCourseByTab({ tab: tab.key })
      updateViewedSearchResultTabAction({ tab: tab.key })
    }

    if (isCourseListPage) {
      // const params = new URLSearchParams(slideParams[tab.key]).toString()
      // history.push(`${ROUTES_NAME.COURSE_LIST}?fromTab=${tab.key}&${params}`)
      history.push(`${ROUTES_NAME.COURSE_LIST}?fromTab=${tab.key}`)
    }

    if (isSearchResultPage) {
      history.push(`${ROUTES_NAME.SEARCH_RESULT}?fromTab=${tab.key}`)
    }
  }

  const onGoBack = () => {
    resetFilterCourseListAction()
    history.push(`${ROUTES_NAME.COURSE_LIST}?fromTab=${courseListTab}`)
  }

  const USER_TABS = [{
    name: t('course_list.freeCourse'),
    key: TabsName.FREE_COURSE,
    numberCourse: courseFree.length || 0
  },
  {
    name: t('course_list.paidCourse'),
    key: TabsName.PAID_COURSE,
    numberCourse: courseCost.length || 0
  }]

  const COMPANY_TABS = [{
    name: COMPANY_NAME_JP.COMPANY,
    key: TabsName.COMPANY_COURSE,
    numberCourse: totalCourseCompany
  },
  {
    name: COMPANY_NAME_JP.NISSOKEN,
    key: TabsName.NISSOKEN_COURSE,
    numberCourse: totalCourseNissoken
  }
  // {
  //   name: t('course_screen.new_course'),
  //   key: TabsName.NEW_COURSE,
  //   numberCourse: totalCourseNew || DEFAULT_PAG.total
  // }
  ]

  const NISSOKEN_TABS = [{
    name: COMPANY_NAME_JP.NISSOKEN,
    key: TabsName.NISSOKEN_COURSE,
    numberCourse: totalCourseNissoken
  }]

  useEffect(() => {
    if (isUserCompany) {
      onChangeTab(TabsName.COMPANY_COURSE)
    }
    if (isNissoken) {
      onChangeTab(TabsName.NISSOKEN_COURSE)
    }
    if (userRole === USER_ROLE.INDIVIDUAL_USER) {
      onChangeTab(TabsName.FREE_COURSE)
    }
  }, [])

  useEffect(() => {
    onChangeTab(fromTab)
    if (isCourseListPage) {
      updateViewedTabAction({ tab: fromTab })
    }
    if (isSearchResultPage) {
      updateViewedSearchResultTabAction({ tab: fromTab })
    }
  }, [fromTab, isCourseListPage, isSearchResultPage])

  const buyNow = () => { }

  const handleOnChangePage = (page, pageSize) => {
    window.scrollTo(0, 0)
    if (courseListTab === TabsName.COMPANY_COURSE) {
      getCourseCompany({
        page,
        limit: pageSize,
        categories,
        courseSearch,
        initial: true
      })
    }
    if (courseListTab === TabsName.NISSOKEN_COURSE) {
      getCourseNissoken({
        page,
        limit: pageSize,
        categories,
        courseSearch,
        initial: true
      })
    }
  }

  /**
   * ジョブナレ 新着動画を表示
   */
  const renderCourseNissokenNewList = () => {
    if (!courseNissokenNew.result || courseNissokenNew.result.length === 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseNissokenNew.result)) && (
      <Swiper
        dataSource={courseNissokenNew}
        type={TYPE.NEW}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * ジョブナビ 新着動画を表示
   */
  const renderCourseCompanyNewList = () => {
    if (!courseCompanyNew.result || courseCompanyNew.result.length === 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseCompanyNew.result)) && (
      <Swiper
        dataSource={courseCompanyNew}
        type={TYPE.NEW}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * ジョブナレ おすすめを表示
   */
  const renderCourseNissokenRecommendedList = () => {
    if (!courseNissokenRecommended.result || courseNissokenRecommended.result.length === 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseNissokenRecommended.result)) && (
      <Swiper
        dataSource={courseNissokenRecommended}
        type={TYPE.RECOMMENDED}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * ジョブナビ おすすめを表示
   */
  const renderCourseCompanyRecommendedList = () => {
    if (!courseCompanyRecommended.result || courseCompanyRecommended.result.length === 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseCompanyRecommended.result)) && (
      <Swiper
        dataSource={courseCompanyRecommended}
        type={TYPE.RECOMMENDED}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * ジョブナレ 最近の視聴を表示
   */
  const renderCourseNissokenRecentViewsList = () => {
    if (!courseNissokenRecentViews.result || courseNissokenRecentViews.result.length === 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseNissokenRecentViews.result)) && (
      <Swiper
        dataSource={courseNissokenRecentViews}
        type={TYPE.RECENT_VIEWS}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * ジョブナビ 最近の視聴を表示
   */
  const renderCourseCompanyRecentViewsList = () => {
    if (!courseCompanyRecentViews.result || courseCompanyRecentViews.result.length === 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseCompanyRecentViews.result)) && (
      <Swiper
        dataSource={courseCompanyRecentViews}
        type={TYPE.RECENT_VIEWS}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * ジョブナレのカテゴリーごとのコースリストを表示
   */
  const renderCourseNissokenCategoryList = (key, _categories) => {
    const courses = coursesNissokenByCategories[key]
    if (!courses || courses.result.length === 0 || (categories.length > 0 && _categories.every((x) => !categories.includes(x)))) {
      return <Empty className="course-empty" description={t('common.no_data')} />
    }

    return (isMappable(courses.result)) && (
      <Swiper
        dataSource={courses}
        type={TYPE.CATEGORY}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
        categories={_categories}
        categoryId={key}
      />
    )
  }

  /**
   * ジョブナビのカテゴリーごとのコースリストを表示
   */
  const renderCourseCompanyCategoryList = (key, _categories) => {
    const courses = coursesCompanyByCategories[key]
    if (!courses || courses.result.length === 0 || (categories.length > 0 && _categories.every((x) => !categories.includes(x)))) {
      return <Empty className="course-empty" description={t('common.no_data')} />
    }

    return (isMappable(courses.result)) && (
      <Swiper
        dataSource={courses}
        type={TYPE.CATEGORY}
        slideParams={slideParams[courseListTab]}
        setSlideParams={(params) => setSlideParams({ ...slideParams, [courseListTab]: params })}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
        categories={_categories}
        categoryId={key}
      />
    )
  }

  /**
   * ジョブナレのカテゴリーなしのコースリストを表示
   */
  const renderUncategorizedCourseNissokenList = () => {
    if (!courseUncategorizedNissoken.result || courseUncategorizedNissoken.result.length <= 0 || categories.length > 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseUncategorizedNissoken.result)) && (
      <Swiper
        dataSource={courseUncategorizedNissoken}
        type={TYPE.UNCATEGORIZED}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * ジョブナビのカテゴリーなしのコースリストを表示
   */
  const renderUncategorizedCourseCompanyList = () => {
    if (!courseUncategorizedCompany.result || courseUncategorizedCompany.result.length <= 0 || categories.length > 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (isMappable(courseUncategorizedCompany.result)) && (
      <Swiper
        dataSource={courseUncategorizedCompany}
        type={TYPE.UNCATEGORIZED}
        isUserCompany={isUserCompany}
        isNissoken={isNissoken}
      />
    )
  }

  /**
   * 検索結果を表示
   */
  const renderSearchResults = () => {
    if (!searchResults.result || searchResults.result.length === 0) return <Empty className="course-empty" description={t('common.no_data')} />

    return (
      <div className={`course-tab-content ${isSearching ? 'justifyCenter' : ''} ${isSidebarToggle ? '' : 'sidebar--close'}`}>
        {(isMappable(searchResults.result)) && searchResults.result.map((item) => (
          <CardCourse
            userId={profile.userId}
            key={item.courseId}
            courseId={item.courseId}
            cardImage={item.imagePath}
            description={item.description}
            descriptionText={item.descriptionText}
            listTag={item.tagCourse}
            name={item.courseName}
            courseOverviewText={item.descriptionText}
            icons={item.tagLesson}
            isShowProgress={false}
            coursePrice={item.price}
            voteLikeCourse={voteLikeCourse}
            startTime={dateFormat(item.startDate, FULL_DATE_TIME)}
            endTime={dateFormat(item.endDate, FULL_DATE_TIME)}
            userRole={userRole}
            course={item}
            addToCart={() => addCourseToCart(item)}
            buyNow={() => buyNow(item)}
            isNew={item.statusCourse}
            tab={courseListTab}
            item={item}
            isLiking={isLiking}
            isUpdatingBookmark={isUpdatingBookmark}
            updateBookmarkAction={updateBookmarkAction}
            onNavigate={() => {
              if (isUserCompany || isNissoken) {
                history.push({
                  pathname: `/course/detail/${item.courseId}`,
                  search: `?isCourseList=TRUE&fromTab=${courseListTab}`,
                  state: { flagCount: true }
                })
              } else {
                history.push({
                  pathname: `/course/detail-unregistered/${item.courseId}?fromTab=${courseListTab}`,
                  search: `?isCourseList=TRUE&fromTab=${courseListTab}`,
                  state: { flagCount: true }
                })
              }
            }}
          />
        ))}
      </div>
    )
  }

  const tabs = useMemo(() => {
    if (isUserCompany) return COMPANY_TABS
    if (isNissoken) return NISSOKEN_TABS
    return USER_TABS
  }, [isUserCompany, isNissoken, channelCounts, t])

  return (
    <Wrapper tab={courseListTab}>
      <div className="course-tab">
        <div className="header">
          <TabBar
            currentTab={courseListTab}
            onChange={onTabChange}
            tabs={tabs}
          />
          {/* {isUserCompany && (
          <div className="filter">
            <Checkbox name={COURSE_ATTRIBUTES.REQUIRED} onChange={handleOnCheckBox} checked={checkBoxStatus.required}>
              {t('course_screen.required')}
            </Checkbox>
            <Checkbox name={COURSE_ATTRIBUTES.OPTIONAL} onChange={handleOnCheckBox} checked={checkBoxStatus.optional}>
              {t('course_screen.optional')}
            </Checkbox>
          </div>
          )} */}
        </div>

        <div className={`body ${isSidebarToggle ? '' : 'sidebar--close'}`}>
          {isCourseListPage && !isWorkSpace && (
            <>
              {/* 新着動画 */}
              <div className="course-list">
                <div className="course-list__title">
                  <span className="course-list__title__icon"><LuPartyPopper /></span>
                  {t('course_screen.new_course')}
                </div>
                {/* ジョブナレ 新着動画 */}
                <div hidden={courseListTab !== TabsName.NISSOKEN_COURSE}>
                  <Spin spinning={courseNissokenNewIsLoading && Object.keys(error || {}).length === 0} size="large">
                    {renderCourseNissokenNewList()}
                  </Spin>
                </div>

                {/* ジョブナビ 新着動画 */}
                <div hidden={courseListTab !== TabsName.COMPANY_COURSE}>
                  <Spin spinning={courseCompanyNewIsLoading && Object.keys(error || {}).length === 0} size="large">
                    {renderCourseCompanyNewList()}
                  </Spin>
                </div>
              </div>

              {/* おすすめ動画 */}
              <div className="course-list">
                <div className="course-list__title">
                  <span className="course-list__title__icon"><FaRegThumbsUp /></span>
                  {t('course_screen.recommended_videos')}
                </div>

                {/* ジョブナレ おすすめ動画 */}
                <div hidden={courseListTab !== TabsName.NISSOKEN_COURSE}>
                  <Spin spinning={courseNissokenRecommendedIsLoading && Object.keys(error || {}).length === 0} size="large">
                    {renderCourseNissokenRecommendedList()}
                  </Spin>
                </div>

                {/* ジョブナビ おすすめ動画 */}
                <div hidden={courseListTab !== TabsName.COMPANY_COURSE}>
                  <Spin spinning={courseCompanyRecommendedIsLoading && Object.keys(error || {}).length === 0} size="large">
                    {renderCourseCompanyRecommendedList()}
                  </Spin>
                </div>
              </div>

              {/* 最近の視聴 */}
              <div className="course-list">
                <div className="course-list__title">
                  <span className="course-list__title__icon"><BiMoviePlay /></span>
                  {t('course_screen.recent_views')}
                </div>

                {/* ジョブナレ 最近の視聴 */}
                <div hidden={courseListTab !== TabsName.NISSOKEN_COURSE}>
                  <Spin spinning={courseNissokenRecentViewsIsLoading && Object.keys(error || {}).length === 0} size="large">
                    {renderCourseNissokenRecentViewsList()}
                  </Spin>
                </div>

                {/* ジョブナビ 最近の視聴 */}
                <div hidden={courseListTab !== TabsName.COMPANY_COURSE}>
                  <Spin spinning={courseCompanyRecentViewsIsLoading && Object.keys(error || {}).length === 0} size="large">
                    {renderCourseCompanyRecentViewsList()}
                  </Spin>
                </div>
              </div>
            </>
          )}

          {isCourseListPage && (
            <>
              {/* ジョブナレ カテゴリーごとのコースリスト */}
              <div hidden={courseListTab !== TabsName.NISSOKEN_COURSE} style={{ marginTop: 8 }}>
                {nissokenCategories.length > 0 && nissokenCategories.map(({ title, key, children }) => {
                  // eslint-disable-next-line no-shadow
                  const categories = !children ? [key] : [key, ...children.map(({ key: k }) => k)]
                  const isLoading = coursesNissokenByCategoriesIsLoading[key] || false
                  const isLoad = needsToLoadNissokenCategories.find((item) => item.key === key)?.load || false
                  const callback = () => {
                    setNeedsToLoadNissokenCategories((prev) => prev.map((item) => (item.key === key ? { ...item, load: false } : item)))
                  }

                  return (
                    <div className="course-list" key={key}>
                      <div className="course-list__title">{title}</div>

                      <InView onInView={() => getCourseNissokenByCategories({ categories, limit: 20, callback, initial: true })} isLoad={isLoad} options={{ rootMargin: '300px' }}>
                        <Spin spinning={isLoading} size="large">
                          {renderCourseNissokenCategoryList(key, categories)}
                        </Spin>
                      </InView>
                    </div>
                  )
                })}

                {isWorkSpace && nissokenCategories.length === 0 ? (<Empty className="course-empty" description={t('common.no_categories')} />) : null}
              </div>

              {/* ジョブナビ カテゴリーごとのコースリスト */}
              <div hidden={courseListTab !== TabsName.COMPANY_COURSE} style={{ marginTop: 8 }}>
                {companyCategories.length > 0 && companyCategories.map(({ title, key, children }) => {
                  // eslint-disable-next-line no-shadow
                  const categories = !children ? [key] : [key, ...children.map(({ key: k }) => k)]
                  const isLoading = coursesCompanyByCategoriesIsLoading[key] || false
                  const isLoad = needsToLoadCompanyCategories.find((item) => item.key === key)?.load || false
                  const callback = () => {
                    setNeedsToLoadCompanyCategories((prev) => prev.map((item) => (item.key === key ? { ...item, load: false } : item)))
                  }

                  return (
                    <div className="course-list" key={key}>
                      <div className="course-list__title">{title}</div>

                      <InView onInView={() => getCourseCompanyByCategories({ categories, limit: 20, callback, initial: true })} isLoad={isLoad} options={{ rootMargin: '300px' }}>
                        <Spin spinning={isLoading} size="large">
                          {renderCourseCompanyCategoryList(key, categories)}
                        </Spin>
                      </InView>
                    </div>
                  )
                })}

                {isWorkSpace && companyCategories.length === 0 ? (<Empty className="course-empty" description={t('common.no_categories')} />) : null}
              </div>
            </>
          )}

          {isCourseListPage && (
            <>
              {/* ジョブナレ カテゴリーなしのコースリスト */}
              <div hidden={courseListTab !== TabsName.NISSOKEN_COURSE} style={{ marginTop: 8 }}>
                <div className="course-list">
                  <div className="course-list__title">{t('course_screen.uncategorized_course')}</div>

                  <InView
                    onInView={() => getUncategorizedCourseNissoken({ initial: true, page: 1, limit: 20, callback: () => setNeedsToLoadUncategorizedNissoken(false) })}
                    isLoad={needsToLoadUncategorizedNissoken}
                    options={{ rootMargin: '300px' }}
                  >
                    <Spin spinning={courseUncategorizedNissokenIsLoading} size="large">
                      {renderUncategorizedCourseNissokenList()}
                    </Spin>
                  </InView>
                </div>
              </div>

              {/* ジョブナビ カテゴリーなしのコースリスト */}
              <div hidden={courseListTab !== TabsName.COMPANY_COURSE} style={{ marginTop: 8 }}>
                <div className="course-list">
                  <div className="course-list__title">{t('course_screen.uncategorized_course')}</div>

                  <InView
                    onInView={() => getUncategorizedCourseCompany({ initial: true, page: 1, limit: 20, callback: () => setNeedsToLoadUncategorizedCompany(false) })}
                    isLoad={needsToLoadUncategorizedCompany}
                    options={{ triggerOnce: true, rootMargin: '300px' }}
                  >
                    <Spin spinning={courseUncategorizedCompanyIsLoading} size="large">
                      {renderUncategorizedCourseCompanyList()}
                    </Spin>
                  </InView>
                </div>
              </div>
            </>
          )}

          {/* 検索結果 */}
          {isSearchResultPage
          && (
          <Spin
            spinning={isSearching && Object.keys(error || {}).length === 0}
            size="large"
          >
            {renderSearchResults()}
          </Spin>
          )}
        </div>

        {/* ページネーション */}
        {isSearchResultPage && (
        <div style={{ margin: '24px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20 }}>
          <PrimaryButton onClick={onGoBack} title={t('common.back_btn')} />
          <Pagination
            total={searchResults.total}
            current={searchResults.page}
            pageSize={searchResults.limit}
            showSizeChanger={false}
            onChange={handleOnChangePage}
            hideOnSinglePage
          />
        </div>
        )}
      </div>
    </Wrapper>
  )
}

export default CourseTab
